var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchLater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 2.66666C8.6665 2.66666 2.6665 8.66666 2.6665 16C2.6665 23.3333 8.6665 29.3333 15.9998 29.3333C23.3332 29.3333 29.3332 23.3333 29.3332 16C29.3332 8.66666 23.3332 2.66666 15.9998 2.66666ZM15.9998 26.6667C10.1198 26.6667 5.33317 21.88 5.33317 16C5.33317 10.12 10.1198 5.33332 15.9998 5.33332C21.8798 5.33332 26.6665 10.12 26.6665 16C26.6665 21.88 21.8798 26.6667 15.9998 26.6667ZM16.6665 9.33332H14.6665V17.3333L21.5998 21.6L22.6665 19.8667L16.6665 16.2667V9.33332Z",
    fill: "#3D96C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchLater);
export default __webpack_public_path__ + "static/media/watch_later.16085f96542c4b07b6be47ac25cdb0c4.svg";
export { ForwardRef as ReactComponent };